import {
  h2 as emptyList,
  a1 as Unit_getInstance,
  b3 as listOf,
  c3 as listOf_0,
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  j1 as LinkedHashMap,
  y9 as ensureNotNull,
  i9 as Exception,
  k9 as IllegalStateException,
  a as getKClassFromExpression,
  e6 as isInterface,
  a6 as isArray,
  f1 as Collection,
  n1 as Map,
  t1 as Set,
  l1 as List,
  s9 as THROW_CCE,
  p5 as classMeta,
  d4 as toList,
  o1 as MutableCollection,
  i1 as Iterable,
  q1 as MutableMap,
  ea as toString,
  r6 as toString_0,
  u1 as addAll,
  v1 as addAll_0,
  t3 as plus,
  z1 as checkIndexOverflow,
  y2 as last,
  g9 as Enum,
  y5 as hashCode,
  s5 as equals,
} from './kotlin-kotlin-stdlib.mjs';
import {
  r as typeModel,
  f1 as TypeModelSimpleAbstract,
  k as PrimitiveType,
  j as EnumType,
  h as CollectionType,
  i as DataType,
  d as PropertyCharacteristic_MEMBER_getInstance,
} from './net.akehurst.language-type-model.mjs';
import { a as Komposite_getInstance } from './net.akehurst.kotlin.komposite-komposite-processor.mjs';
import { b as KompositeException } from './net.akehurst.kotlin.komposite-komposite-api.mjs';
import {
  b as reflect,
  c as reflect_0,
  a as KotlinxReflect_getInstance,
} from './net.akehurst.kotlinx-kotlinx-reflect.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.i4i_1 = 'namespace kotlin {\n    primitive Boolean\n    primitive Byte\n    primitive Short\n    primitive Int\n    primitive Long\n    primitive Float\n    primitive Double\n    primitive String\n}\nnamespace kotlin.collections {\n    collection Array<E>\n    collection Collection<E>\n    collection List<E>\n    collection Set<E>\n    collection Map<K,V>\n}';
    var tmp = this;
    var tmp_0 = emptyList();
    tmp.j4i_1 = typeModel('kotlin-std', false, tmp_0, DatatypeRegistry2$Companion$KOTLIN_STD_MODEL$lambda);
    this.k4i_1 = '        namespace java.lang {\n            primitive Boolean\n            primitive Integer\n            primitive Long\n            primitive Float\n            primitive Double\n            primitive String\n        }\n\n        namespace java.util {\n            collection Array<T>\ncollection Collection<T>\ncollection List<T>\n            collection Set<T>\n            collection Map<K,V>\n        }';
  }
}
class DatatypeRegistry2 extends TypeModelSimpleAbstract {
  constructor() {
    Companion_getInstance();
    super('registry');
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.o4i_1 = tmp$ret$0;
  }
  p4i(mapper) {
    // Inline function 'kotlin.collections.set' call
    var tmp0_set = this.o4i_1;
    var tmp1_set = mapper.k4h_1;
    tmp0_set.m3(tmp1_set, mapper);
  }
  q4i(kompositeModel, primitiveMappers) {
    try {
      var result = Komposite_getInstance().x4g(kompositeModel);
      if (null == result.asm) {
        throw KompositeException.s4h('Error processing config string', result.issues.errors, null);
      } else {
        this.r4i(ensureNotNull(result.asm), primitiveMappers);
      }
    } catch ($p) {
      if ($p instanceof Exception) {
        var e = $p;
        throw KompositeException.u4h('Error trying to register datatypes from config string - ' + e.message, e);
      } else {
        throw $p;
      }
    }
  }
  r4i(kompositeModel, primitiveMappers) {
    this.o4i_1.n3(primitiveMappers);
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_forEach = kompositeModel.allNamespace;
    var tmp0_iterator = tmp0_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.kotlin.komposite.common.DatatypeRegistry2.registerFromKompositeModel.<anonymous>' call
      this.addNamespace(element);
    }
  }
  s4i(cls) {
    var tmp0_elvis_lhs = cls.n9();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException.y1('class does not have a simple name!');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var qname = tmp;
    return this.findByQualifiedNameOrNull(qname);
  }
  t4i(cls) {
    return this.o4i_1.u3(cls);
  }
  u4i(clsName) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_firstOrNull = this.o4i_1.k3();
      var tmp0_iterator = tmp0_firstOrNull.u();
      while (tmp0_iterator.h1()) {
        var element = tmp0_iterator.j1();
        var tmp$ret$0;
        // Inline function 'net.akehurst.kotlin.komposite.common.DatatypeRegistry2.findPrimitiveMapperBySimpleName.<anonymous>' call
        tmp$ret$0 = element.k4h_1.n9() === clsName;
        if (tmp$ret$0) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  v4i(value) {
    var tmp = this.findFirstByNameOrNull(ensureNotNull(getKClassFromExpression(value).n9()));
    return !(tmp == null) ? isInterface(tmp, PrimitiveType) : false;
  }
  w4i(value) {
    var tmp = this.findFirstByNameOrNull(ensureNotNull(getKClassFromExpression(value).n9()));
    return !(tmp == null) ? isInterface(tmp, EnumType) : false;
  }
  x4i(value) {
    var tmp0_subject = value;
    var tmp;
    if (isInterface(tmp0_subject, List)) {
      var tmp_0 = this.findFirstByNameOrNull('List');
      tmp = !(tmp_0 == null) ? isInterface(tmp_0, CollectionType) : false;
    } else {
      if (isInterface(tmp0_subject, Set)) {
        var tmp_1 = this.findFirstByNameOrNull('Set');
        tmp = !(tmp_1 == null) ? isInterface(tmp_1, CollectionType) : false;
      } else {
        if (isInterface(tmp0_subject, Map)) {
          var tmp_2 = this.findFirstByNameOrNull('Map');
          tmp = !(tmp_2 == null) ? isInterface(tmp_2, CollectionType) : false;
        } else {
          if (isInterface(tmp0_subject, Collection)) {
            var tmp_3 = this.findFirstByNameOrNull('Collection');
            tmp = !(tmp_3 == null) ? isInterface(tmp_3, CollectionType) : false;
          } else {
            if (isArray(tmp0_subject)) {
              var tmp_4 = this.findFirstByNameOrNull('Array');
              tmp = !(tmp_4 == null) ? isInterface(tmp_4, CollectionType) : false;
            } else {
              var tmp_5 = this.findFirstByNameOrNull(ensureNotNull(getKClassFromExpression(value).n9()));
              tmp = !(tmp_5 == null) ? isInterface(tmp_5, CollectionType) : false;
            }
          }
        }
      }
    }
    return tmp;
  }
  y4i(value) {
    var tmp = this.findFirstByNameOrNull(ensureNotNull(getKClassFromExpression(value).n9()));
    return !(tmp == null) ? isInterface(tmp, DataType) : false;
  }
  z4i(value) {
    var tmp0_subject = value;
    var tmp;
    if (isInterface(tmp0_subject, List)) {
      var tmp_0 = this.findFirstByNameOrNull('List');
      tmp = (tmp_0 == null ? true : isInterface(tmp_0, CollectionType)) ? tmp_0 : THROW_CCE();
    } else {
      if (isInterface(tmp0_subject, Set)) {
        var tmp_1 = this.findFirstByNameOrNull('Set');
        tmp = (tmp_1 == null ? true : isInterface(tmp_1, CollectionType)) ? tmp_1 : THROW_CCE();
      } else {
        if (isInterface(tmp0_subject, Map)) {
          var tmp_2 = this.findFirstByNameOrNull('Map');
          tmp = (tmp_2 == null ? true : isInterface(tmp_2, CollectionType)) ? tmp_2 : THROW_CCE();
        } else {
          if (isInterface(tmp0_subject, Collection)) {
            var tmp_3 = this.findFirstByNameOrNull('Collection');
            tmp = (tmp_3 == null ? true : isInterface(tmp_3, CollectionType)) ? tmp_3 : THROW_CCE();
          } else {
            if (isArray(tmp0_subject)) {
              var tmp_4 = this.findFirstByNameOrNull('Array');
              tmp = (tmp_4 == null ? true : isInterface(tmp_4, CollectionType)) ? tmp_4 : THROW_CCE();
            } else {
              var tmp_5 = this.findFirstByNameOrNull(ensureNotNull(getKClassFromExpression(value).n9()));
              tmp = (tmp_5 == null ? true : isInterface(tmp_5, CollectionType)) ? tmp_5 : THROW_CCE();
            }
          }
        }
      }
    }
    return tmp;
  }
}
class Configuration {
  constructor(ELEMENTS, ENTRIES, KEY, VALUE) {
    ELEMENTS = ELEMENTS === VOID ? '$elements' : ELEMENTS;
    ENTRIES = ENTRIES === VOID ? '$entries' : ENTRIES;
    KEY = KEY === VOID ? '$key' : KEY;
    VALUE = VALUE === VOID ? '$value' : VALUE;
    this.a4j_1 = ELEMENTS;
    this.b4j_1 = ENTRIES;
    this.c4j_1 = KEY;
    this.d4j_1 = VALUE;
  }
}
class Builder {
  constructor() {
    this.e4j_1 = new Configuration();
    var tmp = this;
    tmp.f4j_1 = KompositeWalker$Builder$_objectBegin$lambda;
    var tmp_0 = this;
    tmp_0.g4j_1 = KompositeWalker$Builder$_objectEnd$lambda;
    var tmp_1 = this;
    tmp_1.h4j_1 = KompositeWalker$Builder$_propertyBegin$lambda;
    var tmp_2 = this;
    tmp_2.i4j_1 = KompositeWalker$Builder$_propertyEnd$lambda;
    var tmp_3 = this;
    tmp_3.j4j_1 = KompositeWalker$Builder$_mapBegin$lambda;
    var tmp_4 = this;
    tmp_4.k4j_1 = KompositeWalker$Builder$_mapEntryKeyBegin$lambda;
    var tmp_5 = this;
    tmp_5.l4j_1 = KompositeWalker$Builder$_mapEntryKeyEnd$lambda;
    var tmp_6 = this;
    tmp_6.m4j_1 = KompositeWalker$Builder$_mapEntryValueBegin$lambda;
    var tmp_7 = this;
    tmp_7.n4j_1 = KompositeWalker$Builder$_mapEntryValueEnd$lambda;
    var tmp_8 = this;
    tmp_8.o4j_1 = KompositeWalker$Builder$_mapSeparate$lambda;
    var tmp_9 = this;
    tmp_9.p4j_1 = KompositeWalker$Builder$_mapEnd$lambda;
    var tmp_10 = this;
    tmp_10.q4j_1 = KompositeWalker$Builder$_collBegin$lambda;
    var tmp_11 = this;
    tmp_11.r4j_1 = KompositeWalker$Builder$_collElementBegin$lambda;
    var tmp_12 = this;
    tmp_12.s4j_1 = KompositeWalker$Builder$_collElementEnd$lambda;
    var tmp_13 = this;
    tmp_13.t4j_1 = KompositeWalker$Builder$_collSeparate$lambda;
    var tmp_14 = this;
    tmp_14.u4j_1 = KompositeWalker$Builder$_collEnd$lambda;
    var tmp_15 = this;
    tmp_15.v4j_1 = KompositeWalker$Builder$_reference$lambda;
    var tmp_16 = this;
    tmp_16.w4j_1 = KompositeWalker$Builder$_primitive$lambda;
    var tmp_17 = this;
    tmp_17.x4j_1 = KompositeWalker$Builder$_enum$lambda;
    var tmp_18 = this;
    tmp_18.y4j_1 = KompositeWalker$Builder$_nullValue$lambda;
  }
  z4j(configuration) {
    var tmp$ret$0;
    // Inline function 'kotlin.apply' call
    var tmp0_apply = this.e4j_1;
    // Inline function 'kotlin.contracts.contract' call
    configuration(tmp0_apply);
    tmp$ret$0 = tmp0_apply;
  }
  a4k(func) {
    this.f4j_1 = func;
  }
  b4k(func) {
    this.g4j_1 = func;
  }
  c4k(func) {
    this.h4j_1 = func;
  }
  d4k(func) {
    this.i4j_1 = func;
  }
  e4k(func) {
    this.j4j_1 = func;
  }
  f4k(func) {
    this.l4j_1 = func;
  }
  g4k(func) {
    this.n4j_1 = func;
  }
  h4k(func) {
    this.p4j_1 = func;
  }
  i4k(func) {
    this.q4j_1 = func;
  }
  j4k(func) {
    this.s4j_1 = func;
  }
  k4k(func) {
    this.u4j_1 = func;
  }
  l4k(func) {
    this.v4j_1 = func;
  }
  m4k(func) {
    this.w4j_1 = func;
  }
  n4k(func) {
    this.x4j_1 = func;
  }
  o4k(func) {
    this.y4j_1 = func;
  }
  p4k(registry) {
    return new KompositeWalker(this.e4j_1, registry, this.f4j_1, this.g4j_1, this.h4j_1, this.i4j_1, this.j4j_1, this.k4j_1, this.l4j_1, this.m4j_1, this.n4j_1, this.o4j_1, this.p4j_1, this.q4j_1, this.r4j_1, this.s4j_1, this.t4j_1, this.u4j_1, this.v4j_1, this.w4j_1, this.x4j_1, this.y4j_1);
  }
}
class KompositeWalker {
  constructor(configuration, registry, objectBegin, objectEnd, propertyBegin, propertyEnd, mapBegin, mapEntryKeyBegin, mapEntryKeyEnd, mapEntryValueBegin, mapEntryValueEnd, mapSeparate, mapEnd, collBegin, collElementBegin, collElementEnd, collSeparate, collEnd, reference, primitive, enum_0, nullValue) {
    this.q4k_1 = configuration;
    this.r4k_1 = registry;
    this.s4k_1 = objectBegin;
    this.t4k_1 = objectEnd;
    this.u4k_1 = propertyBegin;
    this.v4k_1 = propertyEnd;
    this.w4k_1 = mapBegin;
    this.x4k_1 = mapEntryKeyBegin;
    this.y4k_1 = mapEntryKeyEnd;
    this.z4k_1 = mapEntryValueBegin;
    this.a4l_1 = mapEntryValueEnd;
    this.b4l_1 = mapSeparate;
    this.c4l_1 = mapEnd;
    this.d4l_1 = collBegin;
    this.e4l_1 = collElementBegin;
    this.f4l_1 = collElementEnd;
    this.g4l_1 = collSeparate;
    this.h4l_1 = collEnd;
    this.i4l_1 = reference;
    this.j4l_1 = primitive;
    this.k4l_1 = enum_0;
    this.l4l_1 = nullValue;
  }
  m4l(info, data) {
    var path = emptyList();
    return this.n4l(null, path, info, data);
  }
  n4l(owningProperty, path, info, data) {
    var tmp;
    if (null == data) {
      tmp = this.s4l(path, info);
    } else if (this.r4k_1.v4i(data)) {
      tmp = this.r4l(path, info, data);
    } else if (this.r4k_1.w4i(data)) {
      tmp = this.q4l(path, info, data);
    } else if (this.r4k_1.x4i(data)) {
      tmp = this.p4l(owningProperty, path, info, data);
    } else if (this.r4k_1.y4i(data)) {
      tmp = this.o4l(owningProperty, path, info, data);
    } else {
      throw KompositeException.t4h("Don't know how to walk object of class: " + getKClassFromExpression(data));
    }
    return tmp;
  }
  t4l(owningProperty, path, info, propValue) {
    var tmp;
    if (null == propValue) {
      tmp = this.s4l(path, info);
    } else if (this.r4k_1.v4i(propValue)) {
      tmp = this.r4l(path, info, propValue);
    } else if (owningProperty.isComposite) {
      var wi = this.n4l(owningProperty, path, info, propValue);
      tmp = wi;
    } else if (owningProperty.isReference) {
      tmp = this.u4l(owningProperty, path, info, propValue);
    } else {
      throw KompositeException.t4h("Don't know how to walk property " + owningProperty + ' = ' + toString(propValue));
    }
    return tmp;
  }
  o4l(owningProperty, path, info, obj) {
    var cls = getKClassFromExpression(obj);
    var tmp = this.r4k_1.findFirstByNameOrNull(ensureNotNull(cls.n9()));
    var tmp0_elvis_lhs = (tmp == null ? true : isInterface(tmp, DataType)) ? tmp : THROW_CCE();
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp0_error = 'Cannot find datatype for ' + cls + ', is it in the datatype configuration';
      throw IllegalStateException.y1(toString_0(tmp0_error));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var dt = tmp_0;
    var infoob = this.s4k_1(path, info, obj, dt);
    var acc = infoob.w4l_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp1_forEach = dt.allProperty.k3();
    var tmp0_iterator = tmp1_forEach.u();
    while (tmp0_iterator.h1()) {
      var element = tmp0_iterator.j1();
      // Inline function 'net.akehurst.kotlin.komposite.common.KompositeWalker.walkObject.<anonymous>' call
      if (element.characteristics.y()) {
      } else {
        var propValue = get(element, obj);
        var ppath = plus(path, element.name);
        var infopb = this.u4k_1(ppath, new WalkInfo(infoob.v4l_1, acc), element);
        var infowp = this.t4l(element, ppath, new WalkInfo(infoob.v4l_1, infopb.w4l_1), propValue);
        var infope = this.v4k_1(ppath, new WalkInfo(infoob.v4l_1, infowp.w4l_1), element);
        acc = infope.w4l_1;
      }
    }
    return this.t4k_1(path, new WalkInfo(info.v4l_1, acc), obj, dt);
  }
  p4l(owningProperty, path, info, obj) {
    var tmp0_elvis_lhs = this.r4k_1.z4i(obj);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw KompositeException.t4h('CollectionType not found for ' + getKClassFromExpression(obj));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var collDt = tmp;
    var tmp1_subject = obj;
    var tmp_0;
    if (isArray(tmp1_subject)) {
      tmp_0 = this.y4l(owningProperty, path, info, collDt, toList(obj));
    } else {
      if (isInterface(tmp1_subject, Collection)) {
        tmp_0 = this.y4l(owningProperty, path, info, collDt, obj);
      } else {
        if (isInterface(tmp1_subject, Map)) {
          tmp_0 = this.x4l(owningProperty, path, info, collDt, obj);
        } else {
          throw KompositeException.t4h("Don't know how to walk collection of type " + getKClassFromExpression(obj).n9());
        }
      }
    }
    return tmp_0;
  }
  y4l(owningProperty, path, info, type, coll) {
    var infolb = this.d4l_1(path, info, type, coll);
    var acc = infolb.w4l_1;
    var path_elements = plus(path, this.q4k_1.a4j_1);
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator = coll.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      // Inline function 'net.akehurst.kotlin.komposite.common.KompositeWalker.walkColl.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp0_anonymous = checkIndexOverflow(tmp1);
      var ppath = plus(path_elements, tmp0_anonymous.toString());
      var infobEl = new WalkInfo(infolb.v4l_1, acc);
      var infoElb = this.e4l_1(ppath, infobEl, item);
      var infoElv = this.z4l(owningProperty, ppath, infoElb, item);
      var infoEle = this.f4l_1(ppath, infoElv, item);
      var tmp;
      if (tmp0_anonymous < (coll.o() - 1 | 0)) {
        var infoas = this.g4l_1(ppath, infoEle, type, coll, item);
        tmp = new WalkInfo(infolb.v4l_1, infoas.w4l_1);
      } else {
        tmp = new WalkInfo(infolb.v4l_1, infoEle.w4l_1);
      }
      var infoEls = tmp;
      acc = infoEls.w4l_1;
    }
    var infole = new WalkInfo(infolb.v4l_1, acc);
    return this.h4l_1(path, infole, type, coll);
  }
  z4l(owningProperty, path, info, value) {
    var tmp;
    if (null == value) {
      tmp = this.s4l(path, info);
    } else if (this.r4k_1.v4i(value)) {
      tmp = this.r4l(path, info, value);
    } else if (null == owningProperty ? true : owningProperty.isComposite) {
      tmp = this.n4l(owningProperty, path, info, value);
    } else if (owningProperty.isReference) {
      tmp = this.u4l(owningProperty, path, info, value);
    } else {
      throw KompositeException.t4h("Don't know how to walk Collection element " + owningProperty + '[' + last(path) + '] = ' + toString(value));
    }
    return tmp;
  }
  x4l(owningProperty, path, info, type, map) {
    var infolb = this.w4k_1(path, info, map);
    var acc = infolb.w4l_1;
    var path_entries = plus(path, this.q4k_1.b4j_1);
    // Inline function 'kotlin.collections.forEachIndexed' call
    var tmp0_forEachIndexed = map.l3();
    var index = 0;
    var tmp0_iterator = tmp0_forEachIndexed.u();
    while (tmp0_iterator.h1()) {
      var item = tmp0_iterator.j1();
      // Inline function 'net.akehurst.kotlin.komposite.common.KompositeWalker.walkMap.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var tmp1_anonymous = checkIndexOverflow(tmp1);
      var infobEl = new WalkInfo(infolb.v4l_1, acc);
      var ppath = plus(path_entries, tmp1_anonymous.toString());
      var ppathKey = plus(ppath, this.q4k_1.c4j_1);
      var ppathValue = plus(ppath, this.q4k_1.d4j_1);
      var infomekb = this.x4k_1(ppathKey, infobEl, item);
      var infomekv = this.a4m(owningProperty, ppathKey, infomekb, item.o3());
      var infomeke = this.y4k_1(ppathKey, infomekv, item);
      var infomevb = this.z4k_1(ppathValue, infobEl, item);
      var infomev = this.b4m(owningProperty, ppathValue, infomevb, item.p3());
      var infomeve = this.a4l_1(ppathValue, infomev, item);
      var tmp;
      if (tmp1_anonymous < (map.o() - 1 | 0)) {
        var infoas = this.b4l_1(ppath, infomeve, map, item);
        tmp = new WalkInfo(infolb.v4l_1, infoas.w4l_1);
      } else {
        tmp = new WalkInfo(infolb.v4l_1, infomeve.w4l_1);
      }
      var infomes = tmp;
      acc = infomes.w4l_1;
    }
    var infole = new WalkInfo(infolb.v4l_1, acc);
    return this.c4l_1(path, infole, map);
  }
  a4m(owningProperty, path, info, value) {
    return null == value ? this.s4l(path, info) : this.r4k_1.v4i(value) ? this.r4l(path, info, value) : null == owningProperty ? this.n4l(owningProperty, path, info, value) : this.u4l(owningProperty, path, info, value);
  }
  b4m(owningProperty, path, info, value) {
    var tmp;
    if (null == value) {
      tmp = this.s4l(path, info);
    } else if (this.r4k_1.v4i(value)) {
      tmp = this.r4l(path, info, value);
    } else if (null == owningProperty ? true : owningProperty.isComposite) {
      tmp = this.n4l(owningProperty, path, info, value);
    } else if (owningProperty.isReference) {
      tmp = this.u4l(owningProperty, path, info, value);
    } else {
      throw KompositeException.t4h("Don't know how to walk Map value " + owningProperty + '[' + last(path) + '] = ' + toString(value));
    }
    return tmp;
  }
  u4l(owningProperty, path, info, propValue) {
    return null == propValue ? this.s4l(path, info) : this.r4k_1.x4i(propValue) ? this.p4l(owningProperty, path, info, propValue) : this.i4l_1(path, info, propValue, owningProperty);
  }
  q4l(path, info, enum_0) {
    return this.k4l_1(path, info, enum_0 instanceof Enum ? enum_0 : THROW_CCE());
  }
  r4l(path, info, primitive) {
    var mapper = this.r4k_1.t4i(getKClassFromExpression(primitive));
    return this.j4l_1(path, info, primitive, mapper);
  }
  s4l(path, info) {
    return this.l4l_1(path, info);
  }
}
class WalkInfo {
  constructor(up, acc) {
    this.v4l_1 = up;
    this.w4l_1 = acc;
  }
  toString() {
    return 'WalkInfo(up=' + this.v4l_1 + ', acc=' + this.w4l_1 + ')';
  }
  hashCode() {
    var result = this.v4l_1 == null ? 0 : hashCode(this.v4l_1);
    result = imul(result, 31) + (this.w4l_1 == null ? 0 : hashCode(this.w4l_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof WalkInfo))
      return false;
    var tmp0_other_with_cast = other instanceof WalkInfo ? other : THROW_CCE();
    if (!equals(this.v4l_1, tmp0_other_with_cast.v4l_1))
      return false;
    if (!equals(this.w4l_1, tmp0_other_with_cast.w4l_1))
      return false;
    return true;
  }
}
//endregion
function DatatypeRegistry2$Companion$KOTLIN_STD_MODEL$lambda($this$typeModel) {
  var tmp = emptyList();
  $this$typeModel.namespace('kotlin', tmp, DatatypeRegistry2$Companion$KOTLIN_STD_MODEL$lambda$lambda);
  var tmp_0 = emptyList();
  $this$typeModel.namespace('kotlin.collections', tmp_0, DatatypeRegistry2$Companion$KOTLIN_STD_MODEL$lambda$lambda_0);
  return Unit_getInstance();
}
function DatatypeRegistry2$Companion$KOTLIN_STD_MODEL$lambda$lambda($this$namespace) {
  $this$namespace.primitiveType('Boolean');
  $this$namespace.primitiveType('Byte');
  $this$namespace.primitiveType('Short');
  $this$namespace.primitiveType('Int');
  $this$namespace.primitiveType('Long');
  $this$namespace.primitiveType('Float');
  $this$namespace.primitiveType('Double');
  $this$namespace.primitiveType('String');
  $this$namespace.dataType('Any', DatatypeRegistry2$Companion$KOTLIN_STD_MODEL$lambda$lambda$lambda);
  return Unit_getInstance();
}
function DatatypeRegistry2$Companion$KOTLIN_STD_MODEL$lambda$lambda$lambda($this$dataType) {
  return Unit_getInstance();
}
function DatatypeRegistry2$Companion$KOTLIN_STD_MODEL$lambda$lambda_0($this$namespace) {
  $this$namespace.collectionType('Array', listOf('E'));
  $this$namespace.collectionType('Collection', listOf('E'));
  $this$namespace.collectionType('List', listOf('E'));
  $this$namespace.collectionType('Set', listOf('E'));
  $this$namespace.collectionType('Map', listOf_0(['K', 'V']));
  return Unit_getInstance();
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function valueOf(_this__u8e3s4, name) {
  return reflect(get_clazz(_this__u8e3s4)).j4e(name);
}
function construct(_this__u8e3s4, constructorArgs) {
  try {
    var cls = get_clazz(_this__u8e3s4);
    var obj = reflect(cls).g4e(constructorArgs.slice());
    return obj;
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      var tmp = _this__u8e3s4.name;
      var tmp_0 = toList(constructorArgs);
      var tmp0_elvis_lhs = t.message;
      throw KompositeException.t4h('Unable to construct ' + tmp + ' from ' + tmp_0 + ' due to ' + (tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs));
    } else {
      throw $p;
    }
  }
}
function set(_this__u8e3s4, obj, value) {
  try {
    var reflect = reflect_0(obj);
    if (get_isMutable(_this__u8e3s4)) {
      reflect.o4e(_this__u8e3s4.name, value);
    } else {
      var existingValue = reflect.n4e(_this__u8e3s4.name);
      var tmp;
      if (!(existingValue == null) ? isInterface(existingValue, MutableCollection) : false) {
        tmp = !(value == null) ? isInterface(value, Collection) : false;
      } else {
        tmp = false;
      }
      if (tmp) {
        existingValue.n1();
        var tmp_0 = (!(existingValue == null) ? isInterface(existingValue, MutableCollection) : false) ? existingValue : THROW_CCE();
        tmp_0.k1((!(value == null) ? isInterface(value, Collection) : false) ? value : THROW_CCE());
      } else {
        var tmp_1;
        if (!(existingValue == null) ? isInterface(existingValue, MutableCollection) : false) {
          tmp_1 = !(value == null) ? isInterface(value, Iterable) : false;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          existingValue.n1();
          var tmp_2 = (!(existingValue == null) ? isInterface(existingValue, MutableCollection) : false) ? existingValue : THROW_CCE();
          addAll_0(tmp_2, (!(value == null) ? isInterface(value, Iterable) : false) ? value : THROW_CCE());
        } else {
          var tmp_3;
          if (!(existingValue == null) ? isInterface(existingValue, MutableCollection) : false) {
            tmp_3 = !(value == null) ? isArray(value) : false;
          } else {
            tmp_3 = false;
          }
          if (tmp_3) {
            existingValue.n1();
            var tmp_4 = (!(existingValue == null) ? isInterface(existingValue, MutableCollection) : false) ? existingValue : THROW_CCE();
            addAll(tmp_4, (!(value == null) ? isArray(value) : false) ? value : THROW_CCE());
          } else {
            var tmp_5;
            if (!(existingValue == null) ? isInterface(existingValue, MutableMap) : false) {
              tmp_5 = !(value == null) ? isInterface(value, Map) : false;
            } else {
              tmp_5 = false;
            }
            if (tmp_5) {
              existingValue.n1();
              var tmp_6 = (!(existingValue == null) ? isInterface(existingValue, MutableMap) : false) ? existingValue : THROW_CCE();
              tmp_6.n3((!(value == null) ? isInterface(value, Map) : false) ? value : THROW_CCE());
            } else {
              var tmp0_error = 'Cannot set property ' + _this__u8e3s4.owner.name + '.' + _this__u8e3s4.name + ' to ' + toString(value) + ' because it is not a mutable property or Mutable collection';
              throw IllegalStateException.y1(toString_0(tmp0_error));
            }
          }
        }
      }
    }
  } catch ($p) {
    if ($p instanceof Error) {
      var t = $p;
      var tmp_7 = _this__u8e3s4.owner.name;
      var tmp_8 = _this__u8e3s4.name;
      var tmp_9 = toString(value);
      var tmp0_elvis_lhs = t.message;
      throw KompositeException.t4h('Unable to set property ' + tmp_7 + '.' + tmp_8 + ' to ' + tmp_9 + ' due to ' + (tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs));
    } else {
      throw $p;
    }
  }
}
function get_clazz(_this__u8e3s4) {
  return KotlinxReflect_getInstance().a4e(_this__u8e3s4.qualifiedName);
}
function get_isMutable(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.characteristics.w(PropertyCharacteristic_MEMBER_getInstance())) {
    var tmp_0 = _this__u8e3s4.typeInstance.type;
    tmp = !isInterface(tmp_0, CollectionType);
  } else {
    tmp = false;
  }
  return tmp;
}
function get(_this__u8e3s4, obj) {
  var reflect = reflect_0(obj);
  return reflect.n4e(_this__u8e3s4.name);
}
function KompositeWalker$Builder$_objectBegin$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen) {
  return info;
}
function KompositeWalker$Builder$_objectEnd$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen) {
  return info;
}
function KompositeWalker$Builder$_propertyBegin$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_propertyEnd$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_mapBegin$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_mapEntryKeyBegin$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_mapEntryKeyEnd$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_mapEntryValueBegin$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_mapEntryValueEnd$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_mapSeparate$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen) {
  return info;
}
function KompositeWalker$Builder$_mapEnd$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_collBegin$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen) {
  return info;
}
function KompositeWalker$Builder$_collElementBegin$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_collElementEnd$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_collSeparate$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen, _anonymous_parameter_4__qggqds) {
  return info;
}
function KompositeWalker$Builder$_collEnd$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen) {
  return info;
}
function KompositeWalker$Builder$_reference$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen) {
  return info;
}
function KompositeWalker$Builder$_primitive$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi, _anonymous_parameter_3__qggqen) {
  return info;
}
function KompositeWalker$Builder$_enum$lambda(_anonymous_parameter_0__qggqh8, info, _anonymous_parameter_2__qggqfi) {
  return info;
}
function KompositeWalker$Builder$_nullValue$lambda(_anonymous_parameter_0__qggqh8, info) {
  return info;
}
//region block: post-declaration
setMetadataFor(Companion, 'Companion', objectMeta);
setMetadataFor(DatatypeRegistry2, 'DatatypeRegistry2', classMeta);
setMetadataFor(Configuration, 'Configuration', classMeta);
setMetadataFor(Builder, 'Builder', classMeta);
setMetadataFor(KompositeWalker, 'KompositeWalker', classMeta);
setMetadataFor(WalkInfo, 'WalkInfo', classMeta);
//endregion
//region block: exports
export {
  Companion_getInstance as a,
  DatatypeRegistry2 as b,
  Builder as c,
  WalkInfo as d,
  construct as e,
  set as f,
  valueOf as g,
};
//endregion

//# sourceMappingURL=net.akehurst.kotlin.komposite-komposite-common.mjs.map
